<app-menubar></app-menubar>
<router-outlet></router-outlet>